<template>
  <div class="half-graph-container mt-12px">
    <div
      class="
        d-flex
        justify-content-start
        align-items-center
        border-bottom
        px-2
        pb-2
      "
    >
      <div class="dashboardAdmin-cards-head ml-2">License Usage Metrics</div>
    </div>

    <div
      style="margin: auto"
      v-if="showPanelLoader"
      class="d-flex justify-content-center align-items-center h-100"
    >
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <div
      v-else-if="noLicenseUsageData && !showPanelLoader"
      class="d-flex align-items-center justify-content-center w-100 h-100"
    >
      <img src="../../assets/ReportsNew/licenseMetricsNodata.svg" alt="" />
    </div>
    <div v-else id="density_graph"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { usageStats } from "../../utils/apiFunctions";
import { statChart } from "vue-d3-charts-hire3x";
export default {
  props: {
    leadKey: Boolean,
  },
  data() {
    return {
      showPanelLoader: true,
      noLicenseUsageData: true,
    };
  },
  computed: {
    ...mapGetters("userVUEX", {
      roleValues: "getRoleValues",
    }),
  },
  components: {},
  created() {
    this.getUsageStats();
  },
  methods: {
    areAllCountsZero(data, property) {
      return data.every((item) => item[property] === 0);
    },

    async getUsageStats() {
      try {
        const payload = {
          userID: this.roleValues.userID,
          lead: this.leadKey,
        };
        const response = await usageStats(payload);
        if (response.status == 200) {
          const myData = response.data.data;
          if (myData.data.length > 0) {
            this.noLicenseUsageData = this.areAllCountsZero(
              myData.data,
              "count"
            );

            setTimeout(() => {
              if (document.getElementById("density_graph").innerHTML != "") {
                document.getElementById("density_graph").innerHTML = "";
              }
              let densityChart = new statChart();
              densityChart.createDensity(myData.data);
            }, 200);
          }
        }
      } catch (error) {
        console.error(error);
      }
      this.showPanelLoader = false;
    },
  },
};
</script>

<style lang="postcss" scoped></style>
